import { useRef } from 'react';
import { useMutation } from 'react-query';

import DocumentValidationResult from '@app/features/fileHash/types/DocumentValidationResult';
import DocumentValidationData, {
  verifyTargetFile,
} from '@app/store/transport-layer/document/documents/file-hashes/verify';

import uploadFile from '../../libs/uploadFile';

export const FILE_HASH_VERIFICATION_MUTATION_KEY = 'file-hash/verification';

export interface FileHashValidationParam {
  documentId: string;
  file: File;
}

export default function useDocumentValidation() {
  const mutationResult = useMutation<DocumentValidationData, Error, FileHashValidationParam>(
    FILE_HASH_VERIFICATION_MUTATION_KEY,
    mutator,
    {
      onMutate: ({ file }) => {
        fileNameRef.current = file.name.replace('.pdf', '');
      },
    }
  );
  const { data: response } = mutationResult;
  const fileNameRef = useRef<string | null>(null);

  const data: DocumentValidationResult | null = response
    ? {
        ...response,
        fileName: fileNameRef.current ?? '',
      }
    : null;

  const reset = () => {
    fileNameRef.current = null;
    mutationResult.reset();
  };

  return {
    ...mutationResult,
    data,
    reset,
  };
}

async function mutator({ documentId, file }: FileHashValidationParam) {
  const { fileId, otp } = await uploadFile(file);
  return verifyTargetFile({
    fileId,
    otp,
    documentId,
  });
}
